import { remove } from '../index';

export const removeUserFromProject = data => {
  return remove('/projects/share', data);
};
